// FIELD KEY POLICY MANAGEMENT EMPLOYEE
export const WORK_SCHEDULE_CODE_KEY = "workScheduleCode";
export const POLICY_APPLY_DATE_KEY = "effectiveStartDate";
export const POLICY_EXPIRE_DATE_KEY = "endDate";
export const OT_TYPE_KEY = "otType";
export const WORK_SCHEDULE_TYPE_KEY = "ruleType";
export const EXPLANATION_NUMBER_KEY = "explanationNumber";
export const REFUND_HOURS_PER_EXPLANATION_KEY = "refundHoursPerExplanation";
export const EXPLANATION_TIME_PER_DAYS_KEY = "explanationTimePerDays";
export const URL_POLICY_KEY = "urlPolicy";
export const EXPLANATION_RULE_KEY = "explanationRule";
